// frontend/src/services/licenceApi.js
// ============================================================================
// SERVICE API - LICENCES
// ============================================================================

import axios from 'axios';
import { API_URL as API_BASE_URL } from '../config/apiBase';

// S'assurer que le baseURL inclut toujours /api
const BASE_URL = API_BASE_URL;
const API_URL = BASE_URL.endsWith('/api') ? BASE_URL : `${BASE_URL}/api`;

// Créer une instance axios avec config de base
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Intercepteur pour ajouter le token à chaque requête
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les réponses
axiosInstance.interceptors.response.use(
  (response) => {
    // Si la réponse contient { success: true, data: ... }
    if (response.data && response.data.success !== undefined) {
      return response.data;
    }
    // Sinon retourner la réponse telle quelle
    return response.data;
  },
  (error) => {
    // Gestion des erreurs
    if (error.response) {
      // Erreur HTTP (4xx, 5xx)
      const message = error.response.data?.message || error.message;
      return Promise.reject(new Error(message));
    } else if (error.request) {
      // Pas de réponse reçue
      return Promise.reject(new Error('Aucune réponse du serveur'));
    } else {
      // Erreur lors de la configuration de la requête
      return Promise.reject(error);
    }
  }
);

// ============================================================================
// MÉTHODES API LICENCES
// ============================================================================

const licenceApi = {
  /**
   * Récupérer la licence de l'entreprise connectée
   */
  getMaLicence: async () => {
    try {
      const response = await axiosInstance.get('/licences/ma-licence');
      return response;
    } catch (error) {
      console.error('❌ [API] Erreur getMaLicence:', error);
      throw error;
    }
  },

  /**
   * Vérifier si une limite est atteinte
   * @param {string} type - 'employe' ou 'utilisateur'
   */
  verifierLimite: async (type = 'employe') => {
    try {
      const response = await axiosInstance.get(`/licences/verifier/${type}`);
      return response;
    } catch (error) {
      console.error(`❌ [API] Erreur verifierLimite (${type}):`, error);
      throw error;
    }
  },

  /**
   * Récupérer le statut résumé de la licence
   */
  getStatut: async () => {
    try {
      const response = await axiosInstance.get('/licences/statut');
      return response;
    } catch (error) {
      console.error('❌ [API] Erreur getStatut:', error);
      throw error;
    }
  }
};

export default licenceApi;
